// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rich-text,.rich-text p{margin-bottom:20px}.rich-text p{font-size:16px;font-weight:400;color:#000;line-height:30px}.rich-text table{font-size:16px;line-height:1.5;border-top:1px solid #ccc;border-left:1px solid #ccc}.rich-text table th{border-bottom:2px solid #ccc;border-right:1px solid #ccc;text-align:center}.rich-text table td,.rich-text table th{border-bottom:1px solid #ccc;border-right:1px solid #ccc;padding:3px 5px}", ""]);
// Exports
module.exports = exports;
